(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magazine-blog-mv"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    const slideWrapper = $('#header_slider');
    var timers = { slickNext: null };

    slideWrapper.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      if (currentSlide == nextSlide) return;
      slick.$slides.eq(nextSlide).addClass('animate');
    });
    slideWrapper.on('afterChange', function (event, slick, currentSlide) {
      slick.$slides.not(':eq(' + currentSlide + ')').removeClass('animate');
    });
    slideWrapper.on('init', function (slick) {
      $('#header_slider > .slick-list  .slick-slide:first-of-type').addClass('animate');
    });
    slideWrapper.on('swipe', function (event, slick, direction) {
      slideWrapper.slick('setPosition');
    });

    //start the slider
    slideWrapper.slick({
      //slide: '.item',
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoplay: true,
      fade: true,
      autoplaySpeed: autoplaySpeed,
      speed: speed,
      easing: 'easeOutExpo',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">&#xe94b</button>',
      nextArrow: '<button type="button" aria-label="Next" class="slick-next slick-arrow">&#xe94a</button>',
    });

    $('#header_slider_wrap .prev_item').on('click', function () {
      $('#header_slider').slick('slickPrev');
    });
    $('#header_slider_wrap .next_item').on('click', function () {
      $('#header_slider').slick('slickNext');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misawa-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }


    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brand-block-header-list"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const headerHeight = document.querySelector('#shopify-section-header').getBoundingClientRect().height;
    const breadcrumbHeight = document
      .querySelector('.shopify-section.breadcrumb-section')
      .getBoundingClientRect().height;
    const featuredSearchBanner = document.querySelector('.shopify-section.featured-search-banner-wrap');
    const featuredSearchBannerHeight = featuredSearchBanner ? featuredSearchBanner.getBoundingClientRect().height : 0;
    const offset = headerHeight + breadcrumbHeight + featuredSearchBannerHeight;

    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

    anchorLinksArr.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.hash;
        if (targetId) {
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - offset;
            window.scrollTo({
              top: targetOffsetTop,
              behavior: 'smooth',
            });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brand-block-header"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    const headerHeight = document.querySelector('#shopify-section-header').getBoundingClientRect().height;
    const breadcrumbHeight = document
      .querySelector('.shopify-section.breadcrumb-section')
      .getBoundingClientRect().height;
    const featuredSearchBanner = document.querySelector('.shopify-section.featured-search-banner-wrap');
    const featuredSearchBannerHeight = featuredSearchBanner ? featuredSearchBanner.getBoundingClientRect().height : 0;
    const offset = headerHeight + breadcrumbHeight + featuredSearchBannerHeight;

    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks);

    anchorLinksArr.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.hash;
        if (targetId) {
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - offset;
            window.scrollTo({
              top: targetOffsetTop,
              behavior: 'smooth',
            });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
